import { render, staticRenderFns } from "./forex-menu.vue?vue&type=template&id=ff8071c8&scoped=true"
import script from "./forex-menu.vue?vue&type=script&lang=js"
export * from "./forex-menu.vue?vue&type=script&lang=js"
import style0 from "./forex-menu.vue?vue&type=style&index=0&id=ff8071c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8071c8",
  null
  
)

export default component.exports